import { Injectable, Output, EventEmitter } from '@angular/core';


@Injectable()
export class EditFavoriteService {

  @Output() favName = new EventEmitter();

  constructor() { }

  updateFavName(favName) {
    this.favName.emit(favName);
  }
}
